export default {
  title: 'Pagar con Pix',
  hint: 'Copia el código y pégalo en Pix en tu app bancaria, o escanea el código QR con ella.',
  copy: 'Copiar código Pix',
  copied: 'Código copiado',
  qr_alt: 'Código QR de Pix',
  expires_in: 'El código caduca en {{time}}',
  waiting: 'Confirmaremos tu pedido en cuanto tu banco envíe el pago.',
  open_page: 'Abrir la página de pago en su lugar',
  expired: 'Este código Pix ha caducado. Inicia el pago de nuevo para obtener uno nuevo.',
  cancel: 'Cancelar pago',
  checking: 'Comprobando tu pago…',
  close: 'Cerrar',
};
